import type { TOC } from '@ember/component/template-only';

import WizardConnectComponent from 'webapp/components/wizard/connect';

const WizardConnectRouteTemplate: TOC<object> = <template><WizardConnectComponent /></template>;

export default WizardConnectRouteTemplate;
